import { Meta } from '@/metas/meta';

/**
 * 初始化常量
 * @param constant
 */
export const initConstant = (constant: Meta): void => {
    Object.keys(constant.metaData).forEach((key) => {
        const metaItem = constant.metaData[key];
        constant.list.push([metaItem[0], metaItem[1]]);
        // valueEnum
        if (Object.prototype.hasOwnProperty.call(constant, 'valueEnum')) {
            if (metaItem[2]) {
                constant.valueEnum![metaItem[0]] = {
                    text: metaItem[1],
                    status: metaItem[2],
                };
            } else {
                constant.valueEnum![metaItem[0]] = {
                    text: metaItem[1],
                };
            }
        }
        if (Object.prototype.hasOwnProperty.call(constant, 'codeMapping')) {
            (constant as Meta).codeMapping = new Map(constant.list as Array<[number, string]>);
        }
    });
};

/**
 * 初始化多个常量
 */
export const initConstants = (...metas: Meta[]): void => {
    metas.forEach(meta => initConstant(meta));
};
